import gql from 'graphql-tag';
import axios from 'axios';

const UploadImageMutation = gql`
  mutation uploadEvidenceImage {
    data: uploadEvidenceImage {
      success
      image {
        url
        uploadUrl
      }
    }
  }
`;

export const uploadImage = async (client, params) => {
  const url = await client.mutate({
    mutation: UploadImageMutation,
  });

  const uploadUrl = url?.data.data.image.uploadUrl;

  // The accessUrl and fileName should be sent to the backend
  const accessUrl = url?.data.data.image.url;
  const fileSource = params.data.image?.rawFile
    ? params.data.image
    : params.data.pdf;
  const file = fileSource.rawFile;
  const fileName = fileSource.rawFile.name;

  await axios.put(uploadUrl, file, {
    headers: {
      'Content-Type': file.type,
    },
  });

  return { accessUrl, fileName };
};
